import * as React from "react";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { Link } from "react-router-dom";
import MerchantDetailTopBar from "./Ops.Merchants.MerchantDetailTopBar";

class Snapcode extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      data: [],
    };

    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.props.setBreadCrumbs([
      { title: "SnapScan Ops" },
      { title: "Merchants", link: "/snapscan/ops/merchants" },
      { title: this.props.match.params.id, class: "crumbOverflow" },
      { title: "SnapCode" },
    ]);
    this.loadData();
  }

  loadData() {
    this.props.data.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({ data: fetchMoreResult.merchant });
        this.props.setHeader({
          title: `Ops > ${fetchMoreResult.merchant.name}`,
          description: "Merchant summary",
        });
      },
    });
  }

  render() {
    const merchant = this.state.data ? this.state.data : {};
    const name =
      merchant && merchant.merchant_limit_configuration
        ? merchant.merchant_limit_configuration.name
        : "";

    const Codes = (Card) => {
      if (Card.length > 0) {
        return Card.map((code, cdkey) => {
          return (
            <span className="code_block" key={cdkey}>
              <Paper
                style={{
                  transition: "all .7s cubic-bezier(0.23, 1, 0.32, 1) 0ms",
                }}
                className="qrcodeSS"
              >
                <img
                  alt="SnapCode"
                  style={{
                    marginBottom: 30,
                  }}
                  src={`${
                    process.env[
                      "REACT_APP_" + process.env.REACT_APP_ENV + "_LINK"
                    ]
                  }/qr/${code.code}.svg?snap_code_size=140`}
                />
              </Paper>
              <Paper
                elevation={1}
                style={{
                  margin: "5px",
                  display: "inline-block",
                  padding: "10px",
                  textAlign: "center",
                  position: "relative",
                  zIndex: 2,
                }}
              >
                <p>
                  <TextField
                    placeholder={code.code}
                    defaultValue={code.code}
                    disabled={true}
                    style={{
                      width: "200px",
                      minWidth: "200px",
                    }}
                  />
                </p>
                <p>
                  <TextField
                    defaultValue={code.name || "not defined"}
                    label="Nickname"
                    disabled={true}
                    style={{
                      width: "200px",
                      minWidth: "200px",
                    }}
                  />
                </p>
              </Paper>
            </span>
          );
        });
      }
    };

    const Cards = () => {
      if (merchant.cards && merchant.cards.length > 0) {
        return merchant.cards.map((card, ckey) => {
          return (
            <Paper
              key={ckey}
              elevation={1}
              style={{
                margin: "10px",
                padding: "10px",
                display: "inline-block",
                width: "calc(100% - 20px)",
              }}
            >
              <h4
                style={{
                  borderBottom: "1px solid rgb(204, 204, 204)",
                  paddingBottom: "10px",
                  fontWeight: 100,
                }}
              >
                Details
              </h4>

              <div>
                <span>
                  <b>Phone number: </b>
                  {card.instant_money_account &&
                  card.instant_money_account.msisdn
                    ? card.instant_money_account.msisdn
                    : ""}
                </span>
              </div>
              <div>
                <span>
                  <b>Status: </b>
                  {card.instant_money_account &&
                  card.instant_money_account.status
                    ? card.instant_money_account.status
                    : ""}
                </span>
              </div>
              <div>
                <span>
                  <b>Date: </b>
                  {card.instant_money_account &&
                  card.instant_money_account.created_at
                    ? card.instant_money_account.created_at
                    : ""}
                </span>
              </div>
              <h4
                style={{
                  borderBottom: "1px solid rgb(204, 204, 204)",
                  paddingBottom: "10px",
                  fontWeight: 100,
                }}
              >
                Codes
              </h4>
              {Codes(card.qr_codes)}
            </Paper>
          );
        });
      } else {
        return <h1>No Cards</h1>;
      }
    };

    return (
      <React.Fragment>
        <MerchantDetailTopBar />
        <section className="padded scrollable">
          <div style={{ paddingTop: "32px" }} />
          <div>
            <div>
              <Paper
                elevation={1}
                style={{
                  margin: "10px",
                  padding: "10px",
                  display: "inline-block",
                  width: "calc(100% - 20px)",
                }}
              >
                <h3
                  style={{
                    borderBottom: "1px solid rgb(204, 204, 204)",
                    paddingBottom: "10px",
                    fontWeight: 100,
                  }}
                >
                  Merchant
                </h3>
                <div>
                  <span>
                    <b>External Linking </b>
                  </span>
                  <span>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={merchant.dashboard_url}
                    >
                      <button style={{ padding: "4px" }}>
                        Merchant Dashboard
                      </button>
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={merchant.snapmin_url}
                    >
                      <button style={{ padding: "4px" }}>Snapmin</button>
                    </a>
                  </span>
                </div>
                <div>
                  <span>
                    <b>Limit Group: </b>
                    <Link
                      className="blueLink"
                      to={`/snapscan/fraud/merchant_limit_configs/${name}/summary`}
                    >
                      {name}
                    </Link>
                  </span>
                </div>
                <div>
                  <span>
                    <b>Kiosk token: </b>
                    {merchant.kiosk_token}
                  </span>
                </div>
                <div>
                  <span>
                    <b>Kiosk link: </b>{" "}
                    {`https://merchant.getsnapscan.com/kiosk/${merchant.kiosk_token}/transactions`}
                  </span>
                </div>
              </Paper>
              {Cards()}
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

const Merchant = gql`
  query Merchant($id: ID!) {
    merchant(id: $id) {
      name
      email
      kiosk_token
      snapmin_url
      dashboard_url
      merchant_limit_configuration {
        name
      }
      cards {
        created_at
        qr_codes {
          ble_uuid
          code
          name
          created_at
          merchant_reference
          updated_at
        }
        instant_money_account {
          status
          created_at
          msisdn
        }
      }
    }
  }
`;

const merchantSnapcodesWithGraphql = graphql(Merchant, {
  options(props: any) {
    return {
      variables: {
        id: props.match.params.id,
      },
    };
  },
})(Snapcode);
export default merchantSnapcodesWithGraphql;
